export var GitRepositoryStatus;
(function (GitRepositoryStatus) {
    GitRepositoryStatus["GIT_REPOSITORY_STATUS_CONNECTING"] = "CONNECTING";
    GitRepositoryStatus["GIT_REPOSITORY_STATUS_READY"] = "READY";
    GitRepositoryStatus["GIT_REPOSITORY_STATUS_DEGRADED"] = "DEGRADED";
})(GitRepositoryStatus || (GitRepositoryStatus = {}));
